import { render, staticRenderFns } from "./UsersAndRolesView.vue?vue&type=template&id=49bd176c"
import script from "./UsersAndRolesView.vue?vue&type=script&lang=js"
export * from "./UsersAndRolesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports